import type { ComputerViewModelExtended } from './computer-view-model-extended';
import { computersInNetwork } from './computers-in-network';

/**
 * Finds all computers connected to the input computer. If the input computer
 * is not in a network, then return a list with just it self.
 *
 * @param computer the computer to find connect computers for
 * @param computers all computers, should already be filtered and augumented
 *         by computersForMap
 * @returns {*}
 */
export function computersInSameNetwork(
  computer: ComputerViewModelExtended,
  computers: ComputerViewModelExtended[],
): ComputerViewModelExtended[] {
  if (!computer.networkUuid) {
    return [computer];
  } else {
    return computersInNetwork(computers, computer.networkUuid);
  }
}
